import toRRule from "@/helpers/rrules/toRRule";
import toRRuleByweekday from "@/helpers/rrules/toRRuleByweekday";
import toRRuleFreq from "@/helpers/rrules/toRRuleFreq";
import type { RruleOptions } from "@/types";
import { computed, type Ref } from "vue";
import { useI18n } from "vue-i18n";

const RULE_TEXT_MAP: Record<number, string> = {
  1: "templates.rruleinput.texts.day",
  7: "templates.rruleinput.texts.week",
  30: "templates.rruleinput.texts.month",
  365: "templates.rruleinput.texts.year",
};

export function useRRuleOptions(options: Ref<RruleOptions>) {
  const { t } = useI18n();

  const freq = computed(() => toRRuleFreq(options.value.cadence));

  const byweekday = computed(() =>
    toRRuleByweekday(options.value.cadence, options.value.days),
  );

  const rule = computed(() => toRRule(options.value));

  const all = computed(() => rule.value.all());

  const ruleString = computed(() => rule.value.toString());

  const startAt = computed(() => {
    const dates = all.value;
    if (dates.length) {
      return dates.at(0);
    }

    return null;
  });

  const endAt = computed(() => {
    const dates = all.value;
    if (dates.length) {
      return dates.at(-1);
    }

    return null;
  });

  const typeString = computed(() => {
    const { cadence, occurence } = options.value;
    const key = RULE_TEXT_MAP[cadence];
    return t(key || "", occurence);
  });

  return {
    rule,
    all,
    ruleString,
    freq,
    startAt,
    endAt,
    byweekday,
    typeString,
  };
}
